import { useAlbumStore } from '@/store/album'
import type { AttrMultiWatermark, PhotoDetailProps, PhotoOutlineProps, WatermarkPosition } from '@/views/props'
import {
    encode
} from 'js-base64'
import config from '../config'

/**
 * 构造图片地址
 * @param albumPhoto 照片属性
 * @param showSize 展示尺寸
 * @param albumWatermark 水印参数
 */
const OSS_PROCESS = '?x-oss-process=image'

interface WaterParams {
    type: string
    anchor?:number
    path?: string
    position?: number[]
    opacity: number
    scale?: number 
    text?: string
    font?: string
    color?:number[]
    size?: number
    angle?: number
    row?: number
    col?:number
}
export const buildPhotoUrl = (
    albumPhoto: PhotoOutlineProps | PhotoDetailProps,
    albumWatermark: AttrMultiWatermark[],
) => {
    const albumStore = useAlbumStore()
    const array = [...albumWatermark].reverse()
    const fillIndex = array.findIndex(i => i.fill)
    fillIndex === -1 ? array : array.unshift(array.splice(fillIndex, 1)[0])
    const newAlbumWatermark = [...array]
    const outLineWidth = 720
    const detailWidth = 1600
    const obj = {
        outLineUrl: computedPhotoUrl(albumPhoto,outLineWidth),
        detailUrl:  computedPhotoUrl(albumPhoto,detailWidth),
        originUrl: computedPhotoUrl(albumPhoto,0),
        downloadUrl: computedPhotoUrl(albumPhoto, 0),
    }
    let computedWidth = computedPhotoType(albumPhoto).width
    const photoDirection = computedPhotoType(albumPhoto).width >= computedPhotoType(albumPhoto).height
    if (newAlbumWatermark.length > 0 && albumPhoto.showWatermark && albumStore.showWatermark) { 
        obj.outLineUrl = getUrlWithWatermarkNew(obj.outLineUrl, photoDirection, newAlbumWatermark);
        obj.detailUrl = getUrlWithWatermarkNew(obj.detailUrl, photoDirection, newAlbumWatermark);
        obj.originUrl = getUrlWithWatermarkNew(obj.originUrl, photoDirection, newAlbumWatermark);
        obj.downloadUrl = getUrlWithWatermarkNew(obj.originUrl, photoDirection, newAlbumWatermark);
    }
    obj.outLineUrl = `${obj.outLineUrl}${obj.outLineUrl.includes('?') ? '&' : '?'}t=${albumPhoto.beautifulTime}`
    obj.detailUrl = `${obj.detailUrl}${obj.detailUrl.includes('?') ? '&' : '?'}t=${albumPhoto.beautifulTime}`
    obj.originUrl = `${obj.originUrl}${obj.originUrl.includes('?') ? '&' : '?'}t=${albumPhoto.beautifulTime}`
    obj.downloadUrl = `${obj.originUrl}${obj.originUrl.includes('?') ? '&' : '?'}t=${albumPhoto.beautifulTime}`
    return obj
    
}

export const getUrlWithTextWatermark = (
    photoUrl: string,
    photoResize: number,
    photoWidth: number,
    photoHeight: number,
    fill: boolean,
    opacity: number,
    size: number,
    textContent: string,
    textFontColor: string,
    xoffset: number,
    yoffset: number,
    position: WatermarkPosition
) => {
    const photoResizeHeight = (photoHeight * photoResize) / photoWidth
    // 文字base64转码
    const text = encode(textContent).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '')
    // 估算文字大小
    const photoSize = Math.min(Math.floor(photoResize * size), 1000);
    // 构造水印参数
    textFontColor = textFontColor.replace('#', '')
    let watermarkParam = `/watermark,text_${text},color_${textFontColor},size_${photoSize},t_${opacity},g_${position}`
    if (fill) {
        watermarkParam += ',fill_1,rotate_45'
    } else {
        watermarkParam += `,fill_0,x_${handleBeyondBorder(Math.min(Math.round(xoffset * photoResize), 4096))},y_${handleBeyondBorder(Math.min(Math.round(yoffset * photoResizeHeight), 4096))}`
    }
    // 构造图片地址
    if (photoUrl.indexOf(OSS_PROCESS) >= 0) {
        photoUrl += watermarkParam
    } else {
        photoUrl += OSS_PROCESS + watermarkParam
    }
    // console.log('Watermark Url = ', photoUrl)
    return photoUrl
}

export const getUrlWithImgWatermark = (
    photoUrl: string,
    photoResize: number,
    photoWidth: number,
    photoHeight: number,
    opacity: number,
    size: number,
    wmUrl: string,
    xoffset: number,
    yoffset: number,
    position: WatermarkPosition,
    width:number,
    height:number
) => {
    const albumStore = useAlbumStore()
    const { cndUrl } = albumStore
    const photoResizeHeight = (photoHeight * photoResize) / photoWidth
    // 图片水印大小重构
    size = size || 5
    // wmUrl = wmUrl.replace(cndUrl, '') + OSS_PROCESS + `/resize,P_${(100 / size).toFixed(0)}`
    const multiplier = 100 / size;

    let w = Math.round(photoResize * multiplier / 100)
    let h = w * height / width
    // if (photoUrl.includes('1495884')) {
    //     console.log('photoResize-->' + photoResize  + '  P值：' + multiplier + '  w:' + w + '  h:' + h)
    // }
    wmUrl = wmUrl.replace(cndUrl, '') + OSS_PROCESS + `/resize,m_fixed,type_2,w_${Math.round(w)},h_${Math.round(h)},limit_0/format,png`
    // wmUrl = wmUrl.replace(cndUrl, '') + OSS_PROCESS + `/resize,m_fixed,type_2,w_560,h_88,limit_0/format,png`
    // 图片水印参数base64转码
    const img = encode(wmUrl).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '')
    // 构造水印参数
    const watermarkParam = `/watermark,image_${img},t_${opacity},g_${position},x_${handleBeyondBorder(Math.min(Math.round(xoffset * photoResize), 4096))},y_${handleBeyondBorder(
        Math.min(Math.round(yoffset * photoResizeHeight), 4096)
    )}`
    // 构造图片地址
    if (photoUrl.indexOf(OSS_PROCESS) >= 0) {
        photoUrl += watermarkParam
    } else {
        photoUrl += OSS_PROCESS + watermarkParam
    }
    return photoUrl
}


const computedPhotoUrl = (albumPhoto: PhotoOutlineProps | PhotoDetailProps, width: Number) => {
    const albumStore = useAlbumStore()
    const { cndUrl } = albumStore
    let WATER_BASEURL = cndUrl + config.EVN.env
    let segment:string = ''
    let url:string = ''
    switch (albumPhoto.releaseType) {
        case 'ORIGIN':
            segment = width === 0 ? 'compress' : `compress_${width}`
        break;
        case 'COMPRESS':
            segment = width === 0 ? 'compress' : `compress_${width}`
        break;
        case 'BEAUTIFUL':
            segment = width === 0 ? 'beautiful' : `beautiful_${width}`
        break;
        case 'MANUAL':
            segment = width === 0 ? 'manual' : `manual_${width}`
        break;
    }

    url = `${WATER_BASEURL}/${albumPhoto.albumId}/${segment}/${albumPhoto.photoId}${albumPhoto.fileSuffix}`
    return url
}

const computedPhotoType = (item) => {
    let width: number = 0
    let height: number = 0
    switch (item.releaseType) {
        case 'ORIGIN':
            width = item.compressedWidth
            height = item.compressedHeight
        break;
        case 'COMPRESS':
            width = item.compressedWidth
            height = item.compressedHeight
        break;
        case 'BEAUTIFUL':
            width = item.beautifulWidth
            height = item.beautifulHeight
        break;
        case 'MANUAL':
            width = item.manualWidth
            height = item.manualHeight
        break;
    }
    return {width,height}
}

export const replaceErrorPhoto = (url: string) => {
    console.log('图片错误获取https://kp-cdn-res.oss-cn-shanghai.aliyuncs.com照片');
    return url.replace('https://res.kapaisy.com','https://kp-cdn-res.oss-cn-shanghai.aliyuncs.com')
}

const handleBeyondBorder = (num: number): number => {
    // 负数和NaN均返回0
    if (Number.isNaN(num)) {
        return 0;
    }
    return num < 0 ? 0 : num;
}



export const getUrlWithWatermarkNew = (
    photoUrl:string,
    photoDirection: boolean,
    water: AttrMultiWatermark[]
) => {
    const waterParams = [];
    water.forEach(i => {
        let obj: WaterParams = {
            type: getWaterTyp(i),
            opacity:  (i.opacity / 100),
        };
        if (i.type == 'IMG') {
            const urlObj = new URL(i.photoUrl);
            const pathname = urlObj.pathname;
            const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
            obj.path = fileName
            obj.scale = photoDirection ? 1/i.hwatermarkSize : 1/i.vwatermarkSize
            obj.position = [photoDirection ? i.hx : i.vx, photoDirection ? i.hy : i.vy]
            obj.anchor= getPostion(photoDirection ? i.hposition : i.vposition)
        }
        if (i.type == 'TEXT') {
            obj.text = i.textContent;
            obj.color = hexToRgb(i.textFontColor);
            obj.font = 'font/SourceHanSansSC-Normal-2.otf'
            obj.size = photoDirection ?  i.hfontSize :i.vfontSize;
            if (i.fill) {
                obj.angle = 45;
                obj.row = 50;
                obj.col = 50;
            } else {
                obj.anchor = getPostion(photoDirection ? i.hposition : i.vposition)
                obj.angle = 0;
                obj.position = [photoDirection ? i.hx : i.vx, photoDirection ? i.hy : i.vy]
            }
        }
        waterParams.push(obj)
    })
    const base64Code = encode(JSON.stringify(waterParams), true);
    return water.length > 0 ? `${photoUrl}?watermarks=${base64Code}` : photoUrl
}

const getWaterTyp = (item: AttrMultiWatermark) => {
    if (item.type === 'IMG') {
        return 'image'
    } else if (item.type === 'TEXT') {
        if (item.fill) {
            return 'tiled_text'
        } else {
            return 'text'
        }
    }
}


function hexToRgb(hex) {
    // 移除可能存在的前导#
    hex = hex.replace(/^#/, '');
    // 如果是简写形式 (例如: #03F)
    if (hex.length === 3) {
        hex = hex.split('').map(function (char) {
            return char + char;
        }).join('');
    }
    // 检查 hex 是否是有效的六位
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    // 将十六进制转换为 RGB 值
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r,g,b];
}


const getPostion = (position) => {
    let anchor;
    switch (position) {
        case 'nw':
            anchor= 1;
            break;
        case 'sw':
            anchor = 4;
            break;
        case 'ne':
            anchor = 2;
            break;
        case 'se':
            anchor = 3
            break;
    }
    return anchor;
}

// 构造已购照片url
export const buildSellPhotoUrls = (item, albumId) => {
    const albumStore = useAlbumStore()
    const { cndUrl } = albumStore
    let WATER_BASEURL = cndUrl + config.EVN.env;
    let segment = '';
    switch (item.releaseType) {
        case 'ORIGIN':
            segment = `compress`
            break;
        case 'COMPRESS':
            segment = `compress`
            break;
        case 'BEAUTIFUL':
            segment = `beautiful`
            break;
        case 'MANUAL':
            segment = `manual`
            break;
    } 

    const outLineUrl = `${WATER_BASEURL}/${albumId}/${segment}_500/${item.photoId}${item.fileSuffix}`;
    const detailUrl = `${WATER_BASEURL}/${albumId}/${segment}_1600/${item.photoId}${item.fileSuffix}`;
    return {
        outLineUrl,
        detailUrl
    }
}

// 加密
const generateCode =  (str1, str2) => {
    // 将第一个字符串转化为16进制整数
    const hexNum1 = BigInt(`0x${str1}`);
    // 将第二个字符串转化为十进制整数
    const decNum2 = BigInt(str2);
    // 进行异或运算来生成唯一的值
    const xorResult = hexNum1 ^ decNum2;
    // 转换为十六进制字符串并去掉"0x"前缀
    const hexCode = xorResult.toString(16);
    console.log(hexCode)
    return hexCode;
}
